import React from 'react';
import {makeStyles, withStyles} from "@material-ui/core/styles/index";
import Grid from "@material-ui/core/es/Grid/Grid";
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import MakeRequest from "../Filter/Make/MakeRequest";
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import clsx from 'clsx';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import LocationDataRequest from "../Location/LocationDataRequest";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            width: '100%',
            borderBottom: '1px solid #eee',
            paddingBottom: 170,
            ['@media (max-width:500px)']: {
                paddingBottom: 50,
            },
            backgroundPosition: '50% 50%',
            backgroundRepeat: 'no-repeat',
            backgroundImage: 'url(/i/assets/dash-preowned.jpg)',
            backgroundColor: '#000',
            ['@media (max-width:700px)']: {
                backgroundImage: 'url(/i/assets/dash-preowned-mobile.jpg)',
            }
        },
        searchCont: {
            maxWidth: 1000,
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: 180,
            paddingBottom: 50,
            wborder: '1px dashed #3f51b4',
            ['@media (max-width:500px)']: {
                paddingTop: 40,
            }
        },
        search: {
            width: 447,
            overflow: 'hidden',
            marginLeft: 'auto',
            marginRight: 'auto',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: 20,
            borderRadius: 4,
            ['@media (max-width:500px)']: {
                width: 'calc(90% - 30px)',
            }
        },
        h1: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: '1.5rem',
            ['@media (max-width:500px)']: {
                fontSize: '1.2rem',
            },
            ['@media (max-width:375px)']: {
                fontSize: '1.1rem',
            },
            ['@media (max-width:330px)']: {
                fontSize: '.9rem',
            }
        },
        grid: {
            width: '100%',
            marginTop: 20
        },
        gridItem: {
            ['@media (max-width:500px)']: {
                width: '100%',
                paddingRight: '0 !important',
            }
        },
        formControl: {
            ['@media (max-width:500px)']: {
                width: '100%',
            }
        },
        searchGridCont: {
            paddingRight: '0!important',
            ['@media (max-width:500px)']: {
                width: '100%',
            }
        },
        locationGridCont: {
        },
        locationWrap: {
            width: '100%',
            ['@media (max-width:700px)']: {
                position: 'relative',
                backgroundColor: '#fff',
                wborder: '1px solid #3f51b4',
            }
        },
        zipCodeCont: {
            ['@media (max-width:700px)']: {
                width: 'calc(100% - 35px)',
            }
        },
        searchBtn: {
            height: 40,
            ['@media (max-width:500px)']: {
                width: '100%',
                background: '#fff',
                borderRadius: 0,
                border: '1px solid #3f51b4',
                color: '#000'
            }
        },
        iconCont: {
            position: 'absolute',
            cursor: 'pointer',
            width: 35,
            height: 39,
            borderTop: '1px solid #3f51b4',
            borderRight: '1px solid #3f51b4',
            borderBottom: '1px solid #3f51b4',
            top: 0,
            right: 0,
        },
        locationIcon: {
            color: '#3f51b4',
            paddingTop: 8,
            paddingLeft: 6,
            fontSize: '1.4rem',
        },
        progressIcon: {
            color: '#3f51b4',
            fontSize: '1.4rem',
            marginTop: 9,
            marginLeft: 8,
        }
    }}
);

export default function Search(props) {
    const classes = useStyles();

    const [makes, setMakes] = React.useState([]);
    const [models, setModels] = React.useState([]);
    const [modelByMake, setModelByMake] = React.useState({});
    const [make, setMake] = React.useState();
    const [model, setModel] = React.useState();
    const [locationRequested, setLoctionRequested] = React.useState();
    const [locationPayload, setLocationPayload] = React.useState();
    const [zipCodeDefaultValue, setZipCodeDefaultValue] = React.useState();

    const zipCodeRef = React.createRef();

    const onData = (data) => {
        if (!makes.length) {
            data.map(item => {
                makes.push(item.label);
                modelByMake[item.label] = item.model.map(modelItem => {
                    return modelItem.label
                })
            });

        }
    };

    const onError = () => {

    };

    MakeRequest({onData: onData, onError: onError});

    const handleMakeChange = (e) => {
        setMake(e.target.value);
        setModels(modelByMake[e.target.value]);
        setModel(null);
    };

    const handleModelChange = (e) => {
        setModel(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const zipCode = zipCodeRef.current.value;
        window.location.href = '/used-cars'
            +(make ? '/'+make : '')
            +(model ? ','+model : '')
            +(zipCode ? '/distance/50/zipCode/'+zipCode : '')
    };

    const handleRequestLocation = () => {
        setLoctionRequested(true);
        navigator.geolocation.getCurrentPosition(handleNavigatorLocation);
    }

    const handleNavigatorLocation = (p) => {
        setLocationPayload(p)
    }

    const onLocationError = () => {
        setLoctionRequested(false);

        //if (global.loc) {
          //  setLocationPayload(global.loc);
        //}
    }

    const onLocationData = (data) => {
        setLoctionRequested(false);
        setZipCodeDefaultValue(data.zipCode);
    }

    const BootstrapInput = withStyles((theme) => ({
        root: {
            'label + &': {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            maxWidth: 77,
            width: 77,
            ['@media (max-width:500px)']: {
                maxWidth: '100%',
                width: '100%',
                borderRadius: 0,
                '&:focus': {
                    borderRadius: 0,
                    border: '1px solid #3f51b4',
                    boxShadow: 0,
                },
                border: '1px solid #3f51b4',
                color: '#000',
            },
            color: '#555',
            borderRadius: 4,
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            border: '1px solid #ced4da',
            fontSize: 16,
            padding: '10px 26px 10px 12px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            // Use the system font instead of the default Roboto font.
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            '&:focus': {
                borderRadius: 4,
                borderColor: '#80bdff',
                boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
            },
        },
    }))(InputBase);

    const ZipCodeInput = withStyles((theme) => ({
        root: {
            'label + &': {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            color: '#555',
            borderRadius: 4,

            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            border: '1px solid #ced4da',
            fontSize: 16,
            padding: '10px 12px 10px 12px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            // Use the system font instead of the default Roboto font.
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            '&:focus': {
                borderRadius: 4,
                borderColor: '#80bdff',
                boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
            },
            maxWidth: 70,
            ['@media (max-width:500px)']: {
                maxWidth: '100%',
                width: '100%',
                borderRadius: 0,
                '&:focus': {
                    borderRadius: 0,
                },
                border: '1px solid #3f51b4',
                color: '#000'
            }
        },
    }))(InputBase);

    return (
        <div className={classes.root}>
            {locationRequested && locationPayload
                ? <LocationDataRequest payload={locationPayload} onError={onLocationError} onData={onLocationData}/>
                : null}
            <div className={classes.searchCont}>

            </div>
        </div>
    );
}
